import type { ProgressBarAction, ProgressBarState, StepItems } from '@avalara/types/progress-bar';

export const defaultState: ProgressBarState = {
  steps: [],
  currentStep: 0,
};

const getNewSteps = (currentStep: number, steps: Array<StepItems>): Array<StepItems> => {
  return steps.map((step, index) => ({
    ...step,
    active: index === currentStep,
    completed: index < currentStep,
  }));
};

// biome-ignore lint/style/useDefaultParameterLast: this is the order in which Redux wants it
const reducer = (state: ProgressBarState = defaultState, action: ProgressBarAction): ProgressBarState => {
  switch (action.type) {
    case 'INITIALIZE_PROGRESS_BAR':
      return { ...state, steps: action.steps };
    case 'SET_CURRENT_STEP': {
      const currentStep = action.index;
      const newSteps = getNewSteps(currentStep, state.steps);
      return { ...state, currentStep, steps: newSteps };
    }
    case 'SET_PROGRESS_BAR_CURRENT_STEP': {
      const stepIndex = state.steps?.findIndex((step) => step.label === action.label) ?? -1;
      if (stepIndex < 0) return state;
      const newSteps = getNewSteps(stepIndex, state.steps);
      return { ...state, currentStep: stepIndex, steps: newSteps };
    }
    default:
      return state;
  }
};

export default reducer;
